module.exports = __webpack_public_path__ + "img/branch-shanghai.2a7649f1.jpg";